module.exports = __webpack_public_path__ + "static/img/home-group7.74947dc6.png";